/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 *
 * Thin wrapper around the config-driven <UniverseFilter/>. The groups shown are
 * driven by GROUP_PRODUCT_TAGS in common/metadata/FilterConfig.js.
 */

import React from "react";

import UniverseFilter from "./UniverseFilter";

const ContractorUniverseFilter = ({ searchText }) => (
    <UniverseFilter universeKey="CONTRACTOR" searchText={searchText} />
);

export default ContractorUniverseFilter;
